"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectIdentifiers = exports.withoutIdentifiers = exports.applyIdentifiers = void 0;

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var applyIdentifiers = function applyIdentifiers(identifiers) {
  return function (state) {
    var clientIdentifiers = identifiers;
    return _objectSpread({}, state, {
      clientIdentifiers: clientIdentifiers
    });
  };
};

exports.applyIdentifiers = applyIdentifiers;
var withoutIdentifiers = (0, _utils.withoutKey)('clientIdentifiers');
exports.withoutIdentifiers = withoutIdentifiers;

var selectIdentifiers = function selectIdentifiers(state) {
  return state.clientIdentifiers;
};

exports.selectIdentifiers = selectIdentifiers;